<template>
  <MainLayout v-if="!isStandalonePage" />
  <router-view v-else />
  <BitAssistWidget />
</template>

<script>
import MainLayout from './layouts/MainLayout'
import BitAssistWidget from './components/BitAssistWidget.vue'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

export default {
  name: 'App',
  components: {
    MainLayout,
    BitAssistWidget
  },
  setup() {
    const route = useRoute()
    const isStandalonePage = computed(() => route.meta.standalone === true)
    return { isStandalonePage }
  }
}
</script>
